"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initClassifiersFeature = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const defineFeature_1 = require("../base/defineFeature");
const defineClassifierHashEntity_1 = require("./entities/defineClassifierHashEntity");
const shared_1 = require("./shared");
const saveClassifierDefaultData_1 = require("./utils/saveClassifierDefaultData");
const saveClassifierPublicData_1 = require("./utils/saveClassifierPublicData");
function initClassifiersFeature(features) {
    var _a, _b;
    const classifiers = {};
    for (const feature of features) {
        if ((_b = (_a = feature.features) === null || _a === void 0 ? void 0 : _a.classifiers) === null || _b === void 0 ? void 0 : _b.map) {
            for (const [classifierEntityName, classifier] of Object.entries(feature.features.classifiers.map)) {
                if (!classifiers[classifierEntityName]) {
                    classifiers[classifierEntityName] = classifier;
                }
                else {
                    throw new Error(`Cannot include classifier ${classifierEntityName} from feature ${feature.name} into app because it already exists.`);
                }
            }
        }
    }
    if (Object.keys(classifiers).length > 0) {
        const classifierEntities = {};
        for (const [classifierEntityName, classifier] of Object.entries(classifiers)) {
            classifierEntities[classifierEntityName] = Object.assign(Object.assign({}, classifier.entity), { onAuthPost: (appState, userState, params, context) => {
                    var _a, _b, _c, _d;
                    const entityData = (_b = (_a = classifier.entity).onAuthPost) === null || _b === void 0 ? void 0 : _b.call(_a, appState, userState, params, context);
                    if (entityData && params.action !== 'delete') {
                        params = Object.assign(Object.assign({}, params), { data: entityData });
                    }
                    for (const feature of features) {
                        if ((_d = (_c = feature.features) === null || _c === void 0 ? void 0 : _c.classifiers) === null || _d === void 0 ? void 0 : _d.onAuthPost) {
                            const entityData = feature.features.classifiers.onAuthPost(appState, userState, params, context);
                            if (entityData && params.action !== 'delete') {
                                params = Object.assign(Object.assign({}, params), { data: entityData });
                            }
                        }
                    }
                } });
        }
        return (0, defineFeature_1.defineFeature)({
            name: 'classifiers',
            entities: Object.assign({ [shared_1.classifierHashEntityName]: (0, defineClassifierHashEntity_1.defineClassifierHashEntity)() }, classifierEntities),
            onPostDeploy: (context) => {
                var _a, _b;
                for (const feature of features) {
                    if ((_b = (_a = feature.features) === null || _a === void 0 ? void 0 : _a.classifiers) === null || _b === void 0 ? void 0 : _b.map) {
                        for (const [entityName, classifier] of Object.entries(feature.features.classifiers.map)) {
                            if (classifier.defaultData) {
                                const defaultData = typeof classifier.defaultData === 'function' ? classifier.defaultData(context) : classifier.defaultData;
                                if (defaultData.length > 0) {
                                    (0, saveClassifierDefaultData_1.saveClassifierDefaultData)(context, entityName, classifier);
                                }
                            }
                            if (classifier.publicData === true) {
                                (0, saveClassifierPublicData_1.saveClassifierPublicData)(context, { entityName: entityName }, false);
                            }
                            else if (Array.isArray(classifier.publicData)) {
                                for (const savePublicDataParams of classifier.publicData) {
                                    (0, saveClassifierPublicData_1.saveClassifierPublicData)(context, Object.assign(Object.assign({}, savePublicDataParams), { entityName: entityName }), false);
                                }
                            }
                            else if (typeof classifier.publicData === 'function') {
                                classifier.publicData(context.storage(entityName), context.publicData, false);
                            }
                        }
                    }
                }
            },
        });
    }
    else {
        return undefined;
    }
}
exports.initClassifiersFeature = initClassifiersFeature;
